export const root = "rt4952y";
export const rowArrow = "r17imf35";
export const heading = "hjbugse";

require("./style.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");